<template>
  <Modal
    v-model="_value"
    width="500"
    title="添加支出项"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
    <Form ref="loginForm" :model="outlayInfo" :rules="rules" >
      <FormItem prop="name">
        <Input v-model="outlayInfo.name" placeholder="请输入支出项名">
        </Input>
      </FormItem>
      <FormItem prop="receiver">
        <Input v-model="outlayInfo.receiver" placeholder="请输收款方名称">
        </Input>
      </FormItem>
      <FormItem prop="total">
        <InputNumber v-model="outlayInfo.total" placeholder="请输入收款总额">
        </InputNumber>
      </FormItem>
      <FormItem prop="payType">
        <Select v-model="outlayInfo.payType" style="width:200px">
          <Option v-for="item in payType" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="occurrenceDatetime">
        <DatePicker v-model="outlayInfo.occurrenceDatetime" type="date" placeholder="请输入收款时间" style="width: 200px"></DatePicker>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'AddOutlayModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      totalRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '收款总额不能为空', trigger: 'blur' }
          ]
        }
      },
      payTypeRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '支付类型不能为空', trigger: 'blur' }
          ]
        }
      },
      occurrenceDatetimeRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '收款时间不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    data() {
      return {
        payType:[
          {label:'银行转账',value:1},
          {label:'现金支付',value:2},
          {label:'网络支付',value:3},
          ],
        outlayInfo: {
          name:null,
          receiver:null,
          total:0,
          payType:1,
          occurrenceDatetime:null
        }
      }
    },
    methods: {
      ...mapActions([
        'OutlayServ_AddObj'
      ]),
      onOk() {
        this.$Modal.confirm({
          title: '添加支出项',
          content: '<p>是否确认添加支出项</p>',
          onOk: () => {
            store.dispatch('OutlayServ_AddObj', {params: this.outlayInfo}).then(() => {
              this.$Message.success('添加支出项成功')
              this.$emit('on-success');
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail');
            })
          },
          onCancel: () => {
          }
        })
      },
      visibleChange(val) {
        if(val){
          this.outlayInfo.name = null
          this.outlayInfo.receiver = null
          this.outlayInfo.total = 0
          this.outlayInfo.payType = 1
          this.outlayInfo.occurrenceDatetime = null
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          total: this.totalRules,
          payType: this.payTypeRules,
          occurrenceDatetime: this.occurrenceDatetimeRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
